import React from 'react';

// A small, friendly robot face for the assistant's avatar — deliberately
// simple/rounded (no sharp edges) so it reads as cute rather than corporate.
// currentColor-driven so it inherits whatever accent color wraps it.
const BotFace = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* antenna */}
    <circle cx="16" cy="4" r="1.6" fill="currentColor" />
    <line x1="16" y1="5.6" x2="16" y2="8.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    {/* head */}
    <rect x="5" y="8.5" width="22" height="18" rx="8" fill="currentColor" fillOpacity="0.14" />
    <rect x="5" y="8.5" width="22" height="18" rx="8" stroke="currentColor" strokeWidth="1.6" />
    {/* eyes */}
    <circle cx="12.5" cy="17.5" r="2.1" fill="currentColor" />
    <circle cx="19.5" cy="17.5" r="2.1" fill="currentColor" />
    {/* blush */}
    <circle cx="9.3" cy="21" r="1.3" fill="currentColor" fillOpacity="0.35" />
    <circle cx="22.7" cy="21" r="1.3" fill="currentColor" fillOpacity="0.35" />
    {/* smile */}
    <path d="M12.5 21.8c1 1.1 5.9 1.1 7 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export default BotFace;
